<div class="wrap">

    <form [formGroup]="createPasswordForm" (ngSubmit)="onSubmit()">
        <h2>Création du mot de passe : </h2>
        <mat-form-field appearance="outline">
            <mat-label>Mot de passe</mat-label>
            <input type="password" matInput formControlName="password">
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Confirmation du mot de passe</mat-label>
            <input type="password" matInput formControlName="confirmPassword">


        </mat-form-field>
        <div class="btn_action">

            <button [routerLink]="['login']" routerLinkActive="router-link-active" class="cancel" type="button"
                mat-raised-button color="primary">Annuler</button>
            <button type="submit" mat-raised-button color="primary"
                [disabled]="createPasswordForm.invalid">Confirmer</button>
        </div>
    </form>
</div>